import React from "react";

export default () => (<svg viewBox="0 0 15.21 15.21" width="15" height="15">
  <title>Describe</title>
  <path d="M12.32,1.64,8.86,8.77,6.33,7.54,9.83.33a7.63,7.63,0,1,0,2.49,1.31Zm-5.1,9.07L6,11.51l-.1-1.41-.1-1.41,1.28.62,1.28.62Z"/>
</svg>)